import { default as Raven } from 'raven-js';

class LogService {
    public logException(exception: Error, cause: string) {
        Raven.captureException(exception, {
            extra: { cause },
        });
    }

    public logError(message: string, params?: any) {
        this.captureMessage(message, LogLevel.ERROR, params);
    }

    public logWarning(message: string, params?: any) {
        this.captureMessage(message, LogLevel.WARNING, params);
    }

    private captureMessage(message: string, level: LogLevel, params?: any) {
        Raven.captureMessage(message, {
            level,
            extra: { params },
        });
    }
}

export const logService = new LogService();

enum LogLevel {
    ERROR = 'error',
    WARNING = 'warning',
    INFO = 'info'
}
